import { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'aceit_appearance';
const ThemeContext = createContext(null);
const normalize = value => value === 'classic' ? 'classic' : 'bright';
function readTheme() {
  try { return normalize(window.localStorage.getItem(STORAGE_KEY)); } catch { return 'bright'; }
}
function applyTheme(theme) {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.aceTheme = theme;
  document.documentElement.classList.toggle('dark', theme === 'classic');
}
// Apply before the app mounts, including when restoring a saved preference.
if (typeof window !== 'undefined') applyTheme(readTheme());

export function ThemeProvider({ children }) {
  const [theme, updateTheme] = useState(readTheme);
  const setTheme = value => {
    const next = normalize(value);
    applyTheme(next);
    updateTheme(next);
    try { window.localStorage.setItem(STORAGE_KEY, next); } catch { /* Works for this visit if storage is unavailable. */ }
  };
  useEffect(() => {
    const sync = event => {
      if (event.key !== STORAGE_KEY && event.key !== null) return;
      const next = readTheme(); applyTheme(next); updateTheme(next);
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);
  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used inside ThemeProvider');
  return context;
}
